import React from "react";
import { getIcon } from "../../helpers/icons";
import style from './style.module.css';
import Tooltip from "./index";
const WithIcon = ({ children, className, icon = "Question", direction = "top" }) => {
    return (
        <div className={`${style.withIcon}${className ? ` ${className}` : ``}`}>
            <i className={getIcon(icon)}></i>
            <Tooltip direction={direction}>{children}</Tooltip>
        </div>
    )
}
export default WithIcon;